import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';


let config = {
    apiKey: "AIzaSyCga5u6NVtAfMwA_pYzINB0WDJE9B_FFeU",
    authDomain: "murprotect.firebaseapp.com",
    databaseURL: "https://murprotect.firebaseio.com",
    projectId: "murprotect",
    storageBucket: "murprotect.appspot.com",
    messagingSenderId: "403644023276"
};
firebase.initializeApp(config);

export default firebase;


